import React, { useState, useContext } from 'react'
import { LoadingContext, M_Table, BufferService, NavigateContext } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'

export default function ConfigurationEmail({ roles }) {
    const [refresh, setRefresh] = useState(false)
    const bufferServiceNotificationConfig = new BufferService('NotificationConfig')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const NewRoute = (url, label, operation, data) => {
        ctx.passValue.set('operation', operation)
        if (operation === 'create') {
            ctx2.newTab('createConfiguration', t("CreateConfiguration"))
            return
        }
        ctx.passValue.set('lines', data)
        if (operation === 'edit') {
            ctx2.newTab('createConfiguration', t("EditConfiguration"))
            return
        }
    }

    const NewRouteContext = (url, label, operation, data) => {
        ctx.passValue.set('operation', operation)
        if (operation === 'create') {
            ctx2.newTab('createConfiguration', t("CreateConfiguration"))
            return
        }
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }

        if (operation === 'edit') {
            ctx2.newTab('createConfiguration', t("EditConfiguration"))
            return
        }
    }

    const menuTable = (Type) => {
        const nameForRole = 'configurationEmail'
        const tempPerm = []
        const permLines = []
        const permButtons = []
        roles.forEach((role) => {
            if (role.match(nameForRole)) tempPerm.push(role.split(nameForRole)[1])
        })
        if (tempPerm.includes('Create')) {
            //add configuration email
            permLines.push({ label: t("Add"), icon: 'pi pi-plus-circle', command: (data) => NewRouteContext('', '', 'create', data) })
            permButtons.push({
                label: <div className={"spanLabelTables"}>{t("Add")}</div>, element: 'default', source: '/icons/svgsDaNet/add-circle.svg', style: { filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', }, command: (data) => NewRoute('', '', 'create', data)
            })
        }

        if (tempPerm.includes('Edit')) {
            //edit configuration email
            permLines.push({ label: t("Edit"), icon: 'pi pi-pencil', command: (data) => NewRouteContext('', '', 'edit', data) })
            permButtons.push({
                label: <div className={"spanLabelTables"}>{t("Edit")}</div>, element: 'default', source: '/icons/svgsDaNet/edit.svg', style: { filter: 'invert(72%) sepia(44%) saturate(1833%) hue-rotate(12deg) brightness(104%) contrast(101%)' }, command: (data) => NewRoute('', '', 'edit', data)
            })
        }

        if (tempPerm.includes('Delete')) {
            //delete configuration email
            permLines.push({ label: t("Delete"), icon: 'pi pi-trash', command: (data) => deleteTemplateContext(data) })
            permButtons.push({
                label: <div className={"spanLabelTables"}>{t("Delete")}</div>, element: 'default', source: '/icons/svgsDaNet/trash-2.svg', style: { filter: 'invert(13%) sepia(91%) saturate(5396%) hue-rotate(351deg) brightness(95%) contrast(88%)', }, command: (data) => deleteTemplateLine(data)
            })
        }

        if (Type === 'Context') return permLines //context menu
        if (Type === 'Buttons') return permButtons //header table
    }

    const removeContextItems = ['View', 'Create', 'Edit', 'Print']

    const deleteTemplateContext = (data) => {
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }
        bufferServiceNotificationConfig.delete(tempData.Id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorDelete"))
                return
            }
            ctx.toastMessages('success', '', t("SuccessDelete"))
            setTimeout(function () {
                setRefresh(true)
            }, 1000)
        })
    }

    const deleteTemplateLine = (data) => {
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }
        bufferServiceNotificationConfig.delete(tempData.Id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorDelete"))
                return
            }
            ctx.toastMessages('success', '', t("SuccessDelete"))
            setTimeout(function () {
                setRefresh(true)
            }, 1000)
        })
    }


    return (
        <div className='backgroundForms'>
            <div>
                <M_Table
                    filtersOnTable
                    entityName={'NotificationConfig'}
                    removeContextItems={removeContextItems}
                    extraButtons={menuTable('Buttons')}
                    lineContext={menuTable('Context')}
                    refresh={refresh}
                    setRefresh={setRefresh}
                />
            </div>
            <div className='dividerTables'></div>
        </div >
    )
}